import React from "react";
import { Button } from "@/components/ui/button";
import { Lead } from "../types/LeadTypes";
import AudioPlayback from "../AudioPlayback";
import FormFields from "../FormFields";

interface LeadExpandedDetailsProps {
  lead: Lead;
  openTranscriptModal: (id: string) => void;
}

const LeadExpandedDetails: React.FC<LeadExpandedDetailsProps> = ({
  lead,
  openTranscriptModal,
}) => {
  return (
    <div className="space-y-4">
      {lead.aiSummary && (
        <div>
          <h3 className="font-medium text-gray-700 mb-1">AI Summary</h3>
          <p className="text-sm">{lead.aiSummary}</p>
        </div>
      )}

      {lead.type === "Call" && lead.audioDuration && (
        <AudioPlayback duration={lead.audioDuration} audioUrl={lead.audioUrl} />
      )}

      {lead.type === "Form" && lead.formFields && (
        <FormFields fields={lead.formFields} />
      )}

      {lead.type === "Call" && (
        <div>
          <Button
            variant="link"
            className="text-sm p-0 h-auto underline text-black"
            onClick={() => openTranscriptModal(lead.id)}
          >
            Read Transcript
          </Button>
        </div>
      )}
    </div>
  );
};

export default LeadExpandedDetails;
